<template>
    <j-page>
        <div slot="search">
            <j-page-search title="操作时间">
                <j-date-range :start.sync="query.starttime" :end.sync="query.endtime"/>
            </j-page-search>
            <j-page-search title="操作者">
                <el-input v-model="query.title" @keydown.native.enter="searchEvent" placeholder="请输入操作者" clearable />
            </j-page-search>
            <j-page-search title="动作">
                <el-select v-model="query.xxx" placeholder="请选择动作" clearable filterable>
                    <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </j-page-search>
            <el-button type="primary" icon="el-icon-search" @click="searchEvent">查询</el-button>
            <el-button type="info" icon="el-icon-refresh" @click="resetEvent">重置</el-button>
        </div>
        <div slot="table">
            <el-table v-loading="tableLoading" :data="tableData" height="100%" stripe>
                <el-table-column prop="title" label="操作时间" align="center" show-overflow-tooltip />
                <el-table-column prop="title" label="操作者" align="center" show-overflow-tooltip />
                <el-table-column prop="title" label="模块" align="center" show-overflow-tooltip />
                <el-table-column prop="title" label="动作" align="center" show-overflow-tooltip />
                <el-table-column prop="title" label="对象" align="center" show-overflow-tooltip />
                <el-table-column prop="title" label="IP地址" align="center" show-overflow-tooltip />
            </el-table>
        </div>
        <div slot="pagination" v-show="query.total > 0">
            <el-pagination
                    :current-page="query.page"
                    :page-size="query.limit"
                    :total="query.total"
                    :background="pmxBackground"
                    :pager-count="pmxCount"
                    :layout="pmxLayout"
                    :pageSizes="pmxSizes"
                    @current-change="changePage"
                    @size-change="sizeChange"
            />
        </div>
    </j-page>
</template>

<script>
    import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
    import PaginationMixins from "../../components/JComponents/JPage/mixins/PaginationMixins";
    export default {
        name: "LogManage",
        mixins: [PageMixins, PaginationMixins],
        data () {
            return {
                query: {
                    starttime: '',
                    endtime: ''
                }
            }
        },
        created () {
            // this.load()
        },
        methods: {
            async load () {
                this.tableLoading = true
                const { data } = await this.$http.get(`/api/list`, {
                    params: this.query
                })
                this.tableData = data.data.data
                this.query.total = data.data.total
                this.tableLoading = false
            }
        }
    }
</script>
